module.exports = __webpack_public_path__ + "474c483c25ba3374ef947281699d5b25.svg";